import { http } from "../../../config/HttpMethod";
import { WellSurveyServerData } from "../../../store/model/calculations/calculation";
import { ESP_ENDPOINTS } from "../endpoints";


export const importWellSurveyData = async (inputData: FormData): Promise<any> => {
   
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.IMPORT_WELL_SURVEY_DATA}`, inputData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        return response.data;
    } catch (error) {
        console.error('Service error:', error);
        throw error;
    }
};

export const wellSurveyService = {
  // Get existing well survey data
  getExistingWellSurveyData: async (projectId: string): Promise<WellSurveyServerData[]> => {
    try {
      const response = await http.get(`${ESP_ENDPOINTS?.GET_WELL_SURVEY_DATA}${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching well survey data:', error);
      throw error;
    }
  },

  // Clear well survey data
  clearWellSurveyData: async (projectId: string): Promise<void> => {
    try {
      await http.delete(`${ESP_ENDPOINTS?.CLEAR_WELL_SURVEY_DATA}${projectId}`);
    } catch (error) {
      console.error('Error clearing well survey data:', error);
      throw error;
    }
  },


}





